/**
 * O client id do GA4 deste navegador, lido do cookie `_ga` na hora do cadastro.
 *
 * É o que liga a linha do `platform_user` à sessão do GA4 — e é no GA4 que o canal de quem chegou sem
 * parâmetro de campanha (orgânico, direto, referência, social) está classificado. Com o cross-domain
 * entre `vibx.com.br` e `app.vibx.com.br`, o cookie é o mesmo nos dois.
 *
 * O cookie tem a forma `GA1.1.<aleatório>.<timestamp>` e o client id são os dois últimos números.
 * Sem cookie (bloqueador, consentimento recusado, GA fora do ar) devolve `undefined` e o campo
 * simplesmente não vai: medição não derruba cadastro.
 */
const COOKIE_GA = /(?:^|;\s*)_ga=([^;]+)/;
const CLIENT_ID = /^GA\d+\.\d+\.(\d{1,20}\.\d{1,20})$/;

export const parseGaClientId = (cookie: string): string | undefined => {
  const valor = COOKIE_GA.exec(cookie)?.[1];
  if (!valor) return undefined;

  try {
    return CLIENT_ID.exec(decodeURIComponent(valor).trim())?.[1];
  } catch {
    // `%` solto no cookie faz o decode lançar; cookie ilegível é cookie ausente.
    return undefined;
  }
};

export const getGaClientId = (): string | undefined => {
  try {
    return typeof document === 'undefined'
      ? undefined
      : parseGaClientId(document.cookie);
  } catch {
    return undefined;
  }
};
